import { render, staticRenderFns } from "./ReSendPayList.vue?vue&type=template&id=f0ad6230&"
import script from "./ReSendPayList.vue?vue&type=script&lang=js&"
export * from "./ReSendPayList.vue?vue&type=script&lang=js&"
import style0 from "./ReSendPayList.vue?vue&type=style&index=0&id=f0ad6230&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports